import { storeToRefs } from 'pinia';
import { InternalAxiosRequestConfig } from 'axios';
import { useCoreStore } from 'src/stores/core/store';

const requestSpinnerInterceptor = (request: InternalAxiosRequestConfig) => {
  const { pendingRequests } = storeToRefs(useCoreStore());

  if (request?.url) {
    pendingRequests.value.push(request.baseURL + request.url);
  }
  return request;
};

export default requestSpinnerInterceptor;
